import { BoardAccountsView } from './views/boardAccounts'

export const BoardMemberAccountContainer: React.FC = () => <BoardAccountsView />
export default BoardMemberAccountContainer
